import React, { useEffect, useState } from "react";
import { Images } from "../../helper/images";
import TimelineTable from "./timeline-table";
import { useNavigate } from "react-router-dom";
import { DisabledNavLink } from "../../component/sidemenu";
import { SECTION_NAMES } from "../../helper/constant";

const Timeline = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.TIMELINE_AND_COST}</h3>
                <div className="d-flex align-items-center gap-4">
                    <DisabledNavLink to='/ai-usecase'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.AI_USE_CASE_BOOKLET}</p></DisabledNavLink>
                    <DisabledNavLink to='/unique-diffs'><p className="m-0 p-0">{SECTION_NAMES.UNIQUIE_DIFFERENTIATORS}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                </div>
            </div>
            <div className="">
                <TimelineTable />
            </div>

            <h4 className="mt-5">Grants</h4>
            <div className="row">
                <div className="col">
                    <img src={Images.timelineScale} className="w-100" alt="" />
                </div>
                <div className="col">
                    <img src={Images.timelineCDAP} className="w-100" alt="" />
                </div>
                <div className="col">
                    <img src={Images.timelineArc} className="w-100" alt="" />
                </div>
                <div className="col">
                    <img src={Images.timelineSred} className="w-100" alt="" />
                </div>
                <div className="col">
                    <img src={Images.timelineBDC} className="w-100" alt="" />
                </div>
            </div>
            <h4 className="mt-5">Promotions</h4>
            {/* <div style={{ textAlign: "center" }}>
                <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/ai-usecase')}></button>
                <button className={`slick-arrow slick-next slick-next-page`} onClick={() => navigate('/unique-diffs')}></button>
            </div> */}
        </>
    );
};

export default Timeline;
